import './bml-courses-banner.scss';
const TEMPLATE = `
<section class="main-banner-feed fade-up">
    <div class="feed-circles-wrapper" data-animate-circles>
        <!-- Білі кола -->
        <div class="feed-circle feed-circle-extra-large"></div>
        <div class="feed-circle feed-circle-large"></div>
        <div class="feed-circle feed-circle-medium"></div>
    </div>
    <div class="container-fluid">
        <h1 data-animate-child data-delay="200">Освіта з точністю BML</h1>
        <div class="row">
            <div class="col-lg-6"></div>
            <div class="col-lg-6">
                <p class="paragraph-news-feed-banner" data-animate-child data-delay="400">Авторські навчальні
                    програми для лікарів, лаборантів та молодих спеціалістів. Теорія, практика та сертифікація — в
                    середовищі інноваційної лабораторії.</p>
            </div>
        </div>
    </div>
</section>
`;

class BmlCoursesBanner extends HTMLElement {
    connectedCallback() { if (!this.innerHTML.trim()) this.innerHTML = TEMPLATE; }
}
customElements.define('bml-courses-banner', BmlCoursesBanner);
